import React from 'react';

interface InfoCircleProps {
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
  className?: string;
}

export default ({
  width = '16',
  height = '16',
  fill = 'none',
  stroke = 'black',
  className
}: InfoCircleProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Info Tooltip</title>
      <path
        d="M8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.8885V8.77734"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00022 5.71332C7.89708 5.71332 7.79816 5.67235 7.72523 5.59942C7.6523 5.52649 7.61133 5.42758 7.61133 5.32444C7.61133 5.2213 7.6523 5.12238 7.72523 5.04945C7.79816 4.97652 7.89708 4.93555 8.00022 4.93555"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.71332C8.10314 5.71332 8.20206 5.67235 8.27499 5.59942C8.34792 5.52649 8.38889 5.42758 8.38889 5.32444C8.38889 5.2213 8.34792 5.12238 8.27499 5.04945C8.20206 4.97652 8.10314 4.93555 8 4.93555"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
